// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"1363da3b","453":"c8ddb5a6"}[chunkId] + ".chunk.js";
};